export type SearchParamsType = {
  filter: {
    searchText: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  id: number;
  clinicId: number;
  code: string;
  createdByDate: string;
  createdById: number;
  name: string;
  status: number;
};

export type MasterDataType = {
  appointmentId: number;
  appointmentCode: string;
  appointmentName: string;
  appointmentStatus: number;
  appointmentCreatedByDate: string;
  appointmentCreatedById: number;
  appointmentClinicId: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  appointmentCode: string;
  appointmentName: string;
  appointmentStatus: number;
};

export const initialFormData: MasterFormDataType = {
  appointmentCode: "",
  appointmentName: "",
  appointmentStatus: 1,
};

